import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdministrarTiendaService {

  idTienda!: string;

  constructor() { }
}
